/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '@/utils/apiClient';
import {
  PasswordIntroductionPayload,
  PasswordIntroductionResponse,
  PasswordValidationPayload,
  PasswordValidationResponse,
  PasswordConfirmationPayload,
  PasswordConfirmationResponse,
  PasswordChangePayload,
  PasswordChangeResponse,
} from './types';

export const postPasswordIntroduction = createAsyncThunk<
  PasswordIntroductionResponse,
  PasswordIntroductionPayload,
  { rejectValue: string }
>('password/postIntroduction', async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient('/auth/api/v1/password/reset/introduction/', {
      method: 'POST',
      body: payload,
    });
    return res as PasswordIntroductionResponse;
  } catch (err: any) {
    const res: any = err?.response ?? err;
    return rejectWithValue(res?.error || res?.message || 'Introduction failed');
  }
});

export const postPasswordValidation = createAsyncThunk<
  PasswordValidationResponse,
  PasswordValidationPayload,
  { rejectValue: string }
>('password/postValidation', async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient('/auth/api/v1/password/reset/validation/', {
      method: 'POST',
      body: payload,
    });
    return res as PasswordValidationResponse;
  } catch (err: any) {
    const res: any = err?.response ?? err;
    return rejectWithValue(res?.error || res?.message || 'Validation failed');
  }
});

export const postPasswordConfirmation = createAsyncThunk<
  PasswordConfirmationResponse,
  PasswordConfirmationPayload,
  { rejectValue: string }
>('password/postConfirmation', async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient('/auth/api/v1/password/reset/confirmation/', {
      method: 'POST',
      body: payload,
    });
    return res as PasswordConfirmationResponse;
  } catch (err: any) {
    const res: any = err?.response ?? err;
    return rejectWithValue(res?.error || res?.message || 'Confirmation failed');
  }
});

export const postPasswordChange = createAsyncThunk<
  PasswordChangeResponse,
  PasswordChangePayload,
  { rejectValue: string }
>('password/postChange', async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient('/auth/api/v1/password/change/', {
      method: 'POST',
      body: payload,
    });
    return res as PasswordChangeResponse;
  } catch (err: any) {
    const res: any = err?.response ?? err;
    return rejectWithValue(
      res?.error || res?.message || 'Change password failed'
    );
  }
});
